// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"a433fd03","787":"9443df63"}[chunkId] + ".chunk.js";
};